import '../../styles/tutorials.css';
import { SiteLink as Link } from '../../components/SiteLink';
import { PageShell } from '../../components';
import { TutorialSidebar } from '../../components/tutorials/Sidebar';
import { LIVE_SECTIONS, sectionPath, tutorialPath, tutorialsInSection } from '../../content';
import type { TutorialSection } from '../../content';

/** The opening sentence of a section intro, which is what a card has room for. */
const firstSentence = (intro: string) => `${intro.split('. ')[0]}.`;

/**
 * statio.dev/tutorials. One card per section, each pointing at its hub. The
 * full list of every tutorial lives on the hubs: at 60 pages and climbing, a
 * single wall of links tells a reader nothing about where to start.
 */
export default function TutorialsIndex() {
  return (
    <PageShell>
      <div className="s-wrap tu">
        <TutorialSidebar />
        <div className="tu-main">
          <header className="tu-head">
            <h1>MCP tutorials</h1>
            <p className="tu-lede">
              Step-by-step guides for connecting AI clients to MCP servers, building your own and deciding what each
              agent can call, with every step run before it was published.
            </p>
          </header>
          <ul className="tu-cards">
            {LIVE_SECTIONS.map((s) => (
              <SectionCard key={s.id} section={s} />
            ))}
          </ul>
        </div>
      </div>
    </PageShell>
  );
}

function SectionCard({ section }: { section: TutorialSection }) {
  const items = tutorialsInSection(section);
  return (
    <li className="tu-card">
      <h2>
        <Link to={sectionPath(section)}>{section.label}</Link>
      </h2>
      <p className="tu-card-intro">{firstSentence(section.intro)}</p>
      <p className="tu-card-count">
        {items.length} tutorial{items.length === 1 ? '' : 's'}
      </p>
      <ul className="tu-card-list">
        {items.slice(0, 4).map((t) => (
          <li key={t.slug}>
            <Link to={tutorialPath(t.slug)}>{t.title}</Link>
          </li>
        ))}
      </ul>
      <Link className="s-link tu-card-all" to={sectionPath(section)}>
        All {items.length}
      </Link>
    </li>
  );
}
